import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, Mail } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ForgotPasswordDialog = ({ open, onClose }) => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
    } catch (err) {
      // deliberately the same response either way
    } finally {
      setSending(false);
      setSent(true);
    }
  };

  const close = () => {
    setSent(false);
    setEmail('');
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-md" data-testid="forgot-password-dialog">
        <DialogHeader>
          <DialogTitle>Forgot your password?</DialogTitle>
        </DialogHeader>

        {sent ? (
          <div className="space-y-4" data-testid="forgot-password-sent">
            <p className="text-sm text-slate-600">
              If that email address is registered, a reset link is on its way. The link works once and expires in 1 hour.
            </p>
            <Button onClick={close} className="w-full">Back to sign in</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-600">
              Enter the email address you use to sign in and we'll send you a link to set a new password.
            </p>
            <Input
              type="email"
              required
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-password-email"
            />
            <Button type="submit" disabled={sending || !email} className="w-full" data-testid="forgot-password-submit">
              {sending ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Mail className="w-4 h-4 mr-2" />}
              Send reset link
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ForgotPasswordDialog;
